import AutoLinks from 'quill-auto-links';

export const name = 'autoLinks';
export const handler = AutoLinks;
